import { useCallback, useEffect, useState } from 'react';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import { useHistory, useLocation } from 'react-router-dom';
import { Location } from 'history';

type LocationState = {
  from: string;
};

export const useGoBack = (): {
  goBack: () => void;
} => {
  const history = useHistory();
  const location: Location<LocationState> = useLocation();
  const [prevPath, setPrevPath] = useState('');

  useEffect(() => {
    if (location.state && location.state.from) {
      const pathname = location.state.from;
      setPrevPath(pathname);
    }
  }, [location.state]);

  const goBack = useCallback(() => {
    prevPath ? history.push(prevPath) : history.push(MAIN_ROUTES.lobby);
  }, [history, prevPath]);

  return { goBack };
};
